export default "__VITE_ASSET__Mk2ykMpP__"